import { usePaginatedApi } from "../../../swr/useApi";
import { adminProductRequestsService } from "../../api_client";
import type { ProductRequestDto, ProductRequestQueryDto } from "../../../api";
import { ProductRequestQueryDtoRequestStatusEnum } from "../../../api";

export function useAdminDashboardProductApprovals() {
  return usePaginatedApi<ProductRequestDto, ProductRequestQueryDto>({
    key: "admin-dashboard-product-approvals",
    serviceMethod: async (query) => adminProductRequestsService.adminGetAllProductRequests(query),
    query: { requestStatus: ProductRequestQueryDtoRequestStatusEnum.Pending, page: 1, pageSize: 3 },
  });
}
